import React from "react";

const Table = () => {
  return (
    <div>
      <h1>Table Page</h1>
    </div>
  );
};

export default Table;
